var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiscoverIcon = function SvgDiscoverIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 30,
    fill: "none",
    viewBox: "0 0 50 30"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 30,
    fill: "#F5F7FA",
    rx: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#211D1C",
    fillRule: "evenodd",
    d: "M43.464 13.92c0-1.118-.783-1.763-2.156-1.763h-1.759v5.976h1.187v-2.4h.157l1.644 2.4H44l-1.918-2.518c.894-.178 1.387-.78 1.387-1.69zm-11.548 2.251-1.625-4.016h-1.298l2.585 6.132h.64l2.633-6.132h-1.289zm-14.13-1.022c-.003.414.078.824.24 1.206.16.382.398.729.697 1.02.3.29.656.52 1.048.673.391.153.81.228 1.232.22.517 0 1.028-.119 1.489-.349v-1.366c-.47.461-.896.655-1.434.655-1.197 0-2.047-.851-2.047-2.062 0-1.147.877-2.052 1.992-2.052.567 0 .996.198 1.489.671v-1.372a3.1 3.1 0 0 0-1.461-.367 3.3 3.3 0 0 0-1.235.227c-.393.155-.75.384-1.052.675-.301.291-.541.638-.706 1.02s-.25.793-.252 1.207zm-2.128-.699c-.713-.26-.923-.43-.923-.752 0-.377.373-.664.885-.664.357 0 .65.144.959.484l.626-.799a2.7 2.7 0 0 0-1.79-.662c-1.077 0-1.9.734-1.9 1.713 0 .823.383 1.244 1.5 1.639q.426.133.821.341a.72.72 0 0 1 .356.615c0 .484-.393.843-.923.843a1.43 1.43 0 0 1-.769-.21 1.4 1.4 0 0 1-.529-.587l-.767.725c.548.788 1.206 1.138 2.11 1.138 1.235 0 2.1-.805 2.1-1.963 0-.95-.4-1.383-1.752-1.865zm-4.094 3.687h1.187V12.16h-1.187zm-3.82-5.977H6v5.977h1.735c.924 0 1.59-.213 2.175-.69.345-.28.622-.63.813-1.026a2.95 2.95 0 0 0 .293-1.267c0-1.77-1.344-2.999-3.271-2.999zm1.39 4.49c-.373.332-.859.477-1.627.477h-.314v-3.953h.314c.768 0 1.235.133 1.627.482.209.19.375.42.488.676.114.257.171.533.17.813a2 2 0 0 1-.169.82c-.113.26-.28.492-.49.685m26.254 1.487h3.378v-1.01h-2.192v-1.613h2.103V14.5h-2.103v-1.326h2.192V12.16h-3.37v5.976zm5.693-3.226h-.348v-1.814h.367c.739 0 1.141.307 1.141.886 0 .58-.402.925-1.16.925z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#DiscoverIcon_svg__a)",
    fillRule: "evenodd",
    d: "M26.122 12a3.26 3.26 0 0 1 2.282.927c.605.593.945 1.398.946 2.238a3.14 3.14 0 0 1-.97 2.193 3.26 3.26 0 0 1-2.257.903 3.26 3.26 0 0 1-2.257-.903 3.14 3.14 0 0 1-.97-2.193c0-.84.34-1.645.945-2.238A3.26 3.26 0 0 1 26.122 12",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "DiscoverIcon_svg__a",
    x1: 29,
    x2: 25,
    y1: 18,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7991E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE5214"
  })))));
};
export default SvgDiscoverIcon;